class Search {
	stateClasses = {
		open: 'search--open',
	};

	isOpen = false;

	constructor($el) {
		this.$el = $el;
		this.$button = $el.find('[data-search="button"]');
		this.$input = $el.find('[data-search="input"]');
		this.init();
	}

	init = () => {
		this.$button.on('click', this.clickHandler);
		this.$input.on('transitionend', this.transitionendHandler);
	};

	blurHandler = e => {
		this.close();
	};

	clickHandler = () => {
		if (this.isOpen) {
			if (this.$input.val() == '') {
				this.close();
			} else {
				this.$el.submit();
			}
		} else {
			this.open();
		}
	};

	transitionendHandler = () => {
		this.isOpen = !this.isOpen;
	};

	open = () => {
		this.$el.addClass(this.stateClasses.open);
		this.$input.focus();

		this.$input.one('blur', this.blurHandler);
		$(document).on('keyup', this.escapeHandler);
	};

	close = () => {
		if (this.isOpen) {
			this.$el.removeClass(this.stateClasses.open);
			$(document).off('keyup', this.escapeHandler);
		}
	};

	escapeHandler = e => {
		if (e.key === 'Escape') {
			this.close();
		}
	};
}

export default Search;
